import { limit } from "web_myplann/Api/infiniteQueryUtils";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import { useListInfiniteQuery } from "web_myplann/Api/useListInfiniteQuery";
import { getTaskV2 } from "web_myplann/Infrastructure/Api/Api";

export const useTaskListInfiniteQuery = (
	filterDatefrom?: string,
	filterDateto?: string,
	filterOnlyunsolved?: boolean,
	filterOnlysolved?: boolean,
	filterSortdesc?: boolean,
	pageSize: number = limit,
) =>
	useListInfiniteQuery(
		TaskKeys.infiniteList(
			filterDatefrom,
			filterDateto,
			filterOnlyunsolved,
			filterOnlysolved,
			filterSortdesc,
			pageSize,
		),
		(offset) =>
			getTaskV2(
				filterDatefrom,
				filterDateto,
				filterOnlyunsolved,
				filterOnlysolved,
				undefined,
				pageSize,
				offset,
				filterSortdesc,
			),
		{ pageSize },
	);
